module.exports = __webpack_public_path__ + "img/DerBaum.7443c1bd.svg";